// extracted by css-extract-rspack-plugin
export default {"ticketMaskTabPanelContent":"TicketOverlayController_ticketMaskTabPanelContent__FYkpH"};